import React from 'react'

import Select from 'react-select'

export default ({
    onChange,
    options,
    placeholder,
    value
}) => {
    const _onChange = newValue => {
        onChange(newValue.value)
    }

    const _value = value ? options.find(option => option.value === value) : null

    return (
        <Select
            value={_value}
            onChange={_onChange}
            options={options}
            placeholder={placeholder}
            className={'select-container'}
        />
    )
}


// WEBPACK FOOTER //
// ./src/components/input/select.jsx